import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ModalCargarConvenioPago } from "../Modales/ModalCargarConvenioPago";
import { ModalDescargaArchivos } from "../Modales/ModalDescargaArchivos";
import PersonAddIcon from '@mui/icons-material/PersonAdd';

export const CPListadoporcliente = () => {
  const history = useHistory();
  const { state } = useLocation();
  const [clientes, setClientes] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [modalDescarga, setModalDescarga] = useState(false);

  const [folio, setFolio] = useState('')
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const handleOpenModal = (folio) => {
    setOpenModal(true);
    setFolio(folio)
  }

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const abrirModalDescarga = (folio) => {
    setModalDescarga(true);
    setFolio(folio)
  };

  const cerrarModalDescarga = () => {
    setModalDescarga(false);
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ConvenioPago/Listado?idcliente=${Number(state.idcliente)}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setClientes(result)
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
      });
  }, []);


  return (
    <PlantillaScreen
      titulo={`${state.razonsocial}`}
      className={"convenio-pago-main-screen"}
      className_main={1}
    >
      <div className="listado-convenios-cliente">
        <LoaderScreen loader={loader} />
        <div className="listado-convenios-cliente-header">
          <div className="listado-convenios-cliente-header-title">
            <FormatListNumberedIcon /> Listado de Convenios Registrados
          </div>
          <div
            className="listado-convenio-cliente-header-agregar-contacto"
            onClick={() =>
              history.push(
                "/Creditoycobranza/AgregarContacto",
                {
                  idcliente: state.idcliente,
                  razonsocial: state.razonsocial
                }
              )
            }
          >
            <PersonAddIcon /> Registrar Contacto</div>
          <div
            className="listado-convenios-cliente-header-agregar"
            onClick={() =>
              history.push(
                "/Creditoycobranza/GenerarConvenio",
                {
                  idcliente: state.idcliente,
                  razonsocial: state.razonsocial
                }
              )
            }
          >
            <AddCircleOutlineIcon /> Generar Convenio
          </div>
        </div>
        <div className="listado-convenios-cliente-container scroll-4">
          <table>
            <thead>
              <tr>
                <th>Folio</th>
                <th>
                  <div>Fecha de Convenio</div>
                </th>
                <th>
                  <div>Monto</div>
                </th>
                <th>
                  <div>Elaboro</div>
                </th>
                <th>
                  <div></div>
                </th>
              </tr>
            </thead>
            <tbody>
              {clientes.map((vc) => (
                <tr>
                  <td className="ta-center">{vc.folio}</td>
                  <td className="ta-center">{vc.fecha_convenio.split('T')[0]}</td>
                  <td className="ta-center">{FormatMoney(vc.monto)}</td>
                  <td className="ta-center">{vc.nombreCompleto}</td>
                  <td>
                    <div className="convenio-pago-acciones-listado">
                      <div className="boton-descargar-convenio-pago-pdf" onClick={() => abrirModalDescarga(vc.folio)}><CloudDownloadIcon /> Descargar </div>
                      <div className="boton-subir-evidencia-convenio-pago" onClick={() => handleOpenModal(vc.folio)}><CloudUploadIcon />Cargar</div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ModalCargarConvenioPago open={openModal} handleCloseModal={handleCloseModal} folio={folio} />
        <ModalDescargaArchivos open={modalDescarga} onClose={cerrarModalDescarga} folio={folio} />
        <div className="listado-convenios-cliente-footer">
          <div
            className="listado-convenios-cliente-footer-back"
            onClick={() =>
              history.push("/Creditoycobranza/ConvenioPago")
            }
          >
            <ArrowBackIcon /> Regresar
          </div>
        </div>
      </div>
    </PlantillaScreen>
  );
};
